import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Demand, DemandGroup } from "@/savaradio/common";

export const initialLoading = {
  create: false,
  delete: false,
  update: false,
  get: false,
  find: false
}

export type IsLoading = Record<keyof typeof initialLoading, boolean>;

const initialState: { value?: DemandGroup[], isLoading: IsLoading } = { isLoading: initialLoading }

const demandSlice = createSlice({
  name: "demand_slice",
  initialState,
  reducers: {
    append: (state, action: PayloadAction<Demand>) => {
      if (!state.value) state.value = [{
        _id: action.payload.client!,
        count: 1,
        demands: [action.payload]
      }]
      else {
        const target_demand_group = state.value.find(demand_group => demand_group._id === action.payload.client)
        if (
          target_demand_group &&
          !target_demand_group.demands.some(item => item._id === action.payload._id)
        ) {
          state.value = state.value.map(demand_group => {
            if (demand_group._id === target_demand_group._id) return {
              ...target_demand_group,
              count: target_demand_group.count + 1,
              demands: [...target_demand_group.demands, action.payload]
            }
            else return demand_group
          })
        }
        if (!target_demand_group) {
          state.value = [
            ...state.value,
            {
              _id: action.payload.client!,
              count: 1,
              demands: [action.payload]
            }
          ]
        }
      }
    },
    pop: (state, action: PayloadAction<Demand>) => {
      if (state.value) {
        const target_demand_group = state.value.find(demand_group => demand_group._id === action.payload.client)
        if (target_demand_group) {
          state.value = state.value.map(demand_group => {
            if (demand_group._id === target_demand_group._id) return {
              ...target_demand_group,
              count: target_demand_group.count - 1,
              demands: target_demand_group.demands.filter(demand => demand._id !== action.payload._id)
            }
            return demand_group
          })
        }
      }
    },
    merge: (state, action: PayloadAction<Demand>) => {
      if (state.value) {
        const target_demand_group = state.value.find(demand_group => demand_group._id === action.payload.client)
        if (target_demand_group) {
          state.value = state.value.map(demand_group => {
            if (demand_group._id === target_demand_group._id) return {
              ...target_demand_group,
              demands: target_demand_group.demands.map(demand => demand._id === action.payload._id ? action.payload : demand)
            }
            return demand_group
          })
        }
      }
    },
    reset: (state, action: PayloadAction<DemandGroup[] | undefined>) => {
      state.value = action.payload
    },
    setLoading: (state, action: PayloadAction<Partial<IsLoading>>) => {
      state.isLoading = {
        ...state.isLoading,
        ...action.payload
      }
    }
  }
})

export const { append, pop, merge, reset, setLoading } = demandSlice.actions

export const demand_slice = demandSlice.reducer